export default __webpack_public_path__ + "static/media/resourceImg.db7c705b.jpg";